import { ShowHide } from './utils';

enum BtnType {
  TEXT = 'text',
  REMOVE = 'remove',
}

const showHide = {
  wrap: null as HTMLElement | null,
  btn: null as HTMLElement | null,
  images: undefined as NodeListOf<HTMLElement> | undefined,
  init() {
    this.setElements();
    this.setButton();
    this.addBtnListener();
    this.addListener();
    this.reset();
  },

  reset() {
    window.addEventListener('reset', () => {
      this.setElements();
      this.setButton();
      this.addBtnListener();
      this.addListener();
    });
  },

  setElements() {
    this.wrap = document.getElementById('imageWrap');
    this.btn = document.getElementById('showHideImages');
  },
  setButton() {
    if (this.btn) {
      const imgShown = this.btn.dataset.num as string;
      this.images = this.wrap?.querySelectorAll('.jsSingleImage');
      if (this.images && +imgShown < this.images.length) {
        this.btn.classList.remove('d-none');
        const counter = this.btn.querySelector('#imageConter') as HTMLElement;
        if (counter) {
          counter.innerText = `(+${this.images.length - +imgShown})`;
        }
      }
    }
  },

  addBtnListener() {
    this.btn?.addEventListener('click', this.setClasses.bind(this));
  },

  setClasses() {
    if (this.btn && this.wrap) {
      this.btn.classList.toggle('activeClass');
      this.wrap.classList.toggle('activeClass');
      const textEl = this.btn.firstElementChild as HTMLElement;
      const btnType = this.btn?.dataset.type;
      if (btnType === BtnType.TEXT) {
        if (this.btn.classList.contains('activeClass')) {
          textEl.innerText = ShowHide.SHOW_LESS;
        } else {
          textEl.innerText = ShowHide.SHOW_MORE;
        }
      } else {
        this.btn.classList.add('d-none');
      }
    }
  },
  addListener() {
    window.addEventListener('reset', () => {
      this.setElements();
      this.addBtnListener();
    });
  },
};

export default showHide;
